import React from "react";

export default function NotFound() {
  return (
    <div style={{ padding: "80px", textAlign: "center" }}>
      <h1>404 – Page Not Found</h1>
      <p>The page you're looking for doesn’t exist.</p>
      <a href="/" style={{ color: "#0077ff", textDecoration: "underline" }}>
        Go back home
      </a>
    </div>
  );
}

